// frontend/src/pages/marketplace/MarketplaceBusinessesPage.js
import React from 'react';
import BusinessManagementTab from '../../components/community/BusinessManagementTab';
import { ArrowLeft, Store, TrendingUp, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MarketplaceBusinessesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#E8ECF5] pb-16 sm:pb-0">
      {/* Header - Mobile Optimized */}
      <div className="bg-[#E8ECF5] border-b border-primary-100/50 shadow-neomorph sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4 md:py-5">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 sm:gap-4">
            <div className="flex items-center">
              <button
                onClick={() => navigate(-1)}
                className="mr-2 sm:mr-3 md:mr-4 p-1.5 sm:p-2 rounded-lg bg-white shadow-neomorph hover:shadow-neomorph-hover transition-all"
              >
                <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5 text-gray-600" />
              </button>
              <div className="flex items-center">
                <div className="p-2 sm:p-2.5 md:p-3 rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 shadow-lg shadow-primary-500/30 mr-2 sm:mr-3 md:mr-4">
                  <Store className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
                </div>
                <div>
                  <div className="flex items-center mb-0.5 sm:mb-1">
                    <div className="w-1 h-4 sm:h-5 md:h-6 bg-gradient-to-b from-primary-400 to-primary-600 rounded-full mr-1.5 sm:mr-2" />
                    <h1 className="text-base sm:text-lg md:text-xl font-bold text-gray-800">
                      My Businesses
                    </h1>
                  </div>
                  <p className="text-[11px] sm:text-sm text-gray-500 ml-2 sm:ml-3 hidden xs:block md:block">
                    Manage your listings and track performance
                  </p>
                  <p className="text-[10px] text-gray-500 ml-2 xs:hidden">
                    Manage your listings
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 pb-4 sm:pb-6 md:pb-8">
        <div className="bg-white rounded-xl p-3 sm:p-4 md:p-5 shadow-neomorph border border-gray-100 overflow-hidden">
          <BusinessManagementTab />
        </div>
      </div>

      <style jsx>{`
        .shadow-neomorph {
          box-shadow: 6px 6px 11px #d0d6e0, -6px -6px 11px #ffffff;
        }
        .shadow-neomorph-hover {
          box-shadow: 4px 4px 7px #d0d6e0, -4px -4px 7px #ffffff;
        }
        .shadow-neomorph-inset {
          box-shadow: inset 2.5px 2.5px 5px #d0d6e0, inset -2.5px -2.5px 5px #ffffff;
        }
      `}</style>
    </div>
  );
};

export default MarketplaceBusinessesPage;